<template>
  <div>
    <el-dropdown @command="handleCommand">
      <div class="header-user-item">
<!--        <el-avatar icon="el-icon-user-solid"></el-avatar>-->
        <img src="@/assets/img/img01.png" />
        <span>{{tenantInfo.Account}}</span>
      </div>
      <el-dropdown-menu slot="dropdown">
<!--        <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>-->
<!--         <el-dropdown-item command="changeAccount">切换账号</el-dropdown-item>-->
        <el-dropdown-item command="updateNotice"><el-badge :is-dot="hasCheck" style="line-height: 1;">关于版本</el-badge></el-dropdown-item>
        <el-dropdown-item command="logout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 切换账号 -->
    <dialog-change-account
      :showdialog.sync="showChangeAccount"
    ></dialog-change-account>
    <!-- 修改密码 -->
    <dialog-change-pwd :showdialog.sync="showChangePwd"></dialog-change-pwd>
    <!-- 版本更新通知 -->
    <dialog-update-notice :showdialog.sync="showUpdateNotice"></dialog-update-notice>
  </div>
</template>

<script>
import dialogChangeAccount from "./dialogChangeAccount";
import dialogChangePwd from "./dialogChangePwd";
import dialogUpdateNotice from "./dialogUpdateNotice";
import showdialog from '../../../minxs/showdialog';
import { getTenantId } from "@/utils/service";
import { checkVersion } from "@/api/module/tenant";
import { distinguishTitle } from "@/utils/index";

export default {
  components: {
    dialogChangeAccount,
    dialogChangePwd,
    dialogUpdateNotice,
  },
  data() {
    return {
      showChangeAccount: false,
      showChangePwd: false,
      showUpdateNotice: false,
      hasCheck: false,
    };
  },
  computed:{
    tenantInfo:function(){
      return this.$store.state.user.userInfo;
    }
  },
  mixins:[showdialog],
  mounted() {
    if (distinguishTitle() !== '萍乡') this.checkVersion()
  },
  methods: {
    handleCommand(command) {
      this.showChangePwd = false;
      this.showChangeAccount = false;
      // console.log(command);
      switch (command) {
        case "changePwd":
          this.showChangePwd = true;
          break;
        case "changeAccount":
          this.showChangeAccount = true;
          break;
        case "updateNotice":
          this.showUpdateNotice = true;
          this.hasCheck = false;
          break;
        default:
          this.handleLogOut();
          break;
      }
    },
    handleLogOut() {
      // this.
      this.$confirm("确定退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut");
        this.$router.push("/login");
      });
    },
    checkVersion() {
      checkVersion({TenantId: Number(getTenantId()), Project: this.ProjectObj[distinguishTitle()], Product: 4,}).then(res => {
        if (res.state === "success") {
          this.hasCheck = res.data ? res.data.NeedReview : false;
        } else {
          this.$message.error(res.message);
        }
      })
    },
  },
};
</script>

<style lang='scss'>
.header-user-item {
  display: flex;
  justify-content: space-around;
  align-items: center;
  top: 10px;
  & img {
    width: 28px;
    margin-right: 15px;
  }
  & span{
    color: #333;
  }
}
</style>
